// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","host":"bundle-purchase_host__wLsQJ"};